import Matter from 'matter-js';
import { useEffect, useRef } from 'react';

const EmojiBucket = ({ paymentArr }) => {
	const sceneRef = useRef(null); // The div to hold the canvas
	const engineRef = useRef(Matter.Engine.create());

	// 1. Initialize the Physics World
	useEffect(() => {
		const engine = engineRef.current;
		const render = Matter.Render.create({
			element: sceneRef.current,
			engine: engine,
			options: {
				width: 600,
				height: 400,
				wireframes: false,
				background: '#f0f0f0',
			},
		});

		// Create Bucket Walls
		const wallOptions = {
			isStatic: true,
			render: { fillStyle: '#2c3e50' },
		};
		const ground = Matter.Bodies.rectangle(300, 380, 400, 20, wallOptions);
		const leftWall = Matter.Bodies.rectangle(
			100,
			280,
			20,
			200,
			wallOptions
		);
		const rightWall = Matter.Bodies.rectangle(
			500,
			280,
			20,
			200,
			wallOptions
		);

		Matter.Composite.add(engine.world, [ground, leftWall, rightWall]);

		Matter.Render.run(render);
		const runner = Matter.Runner.create();
		Matter.Runner.run(runner, engine);

		return () => {
			Matter.Render.stop(render);
			Matter.Engine.clear(engine);
			render.canvas.remove();
		};
	}, []);

	// 2. Sync React State with Physics World
	useEffect(() => {
		const world = engineRef.current.world;

		// If array is cleared: Remove all non-static bodies (emojis)
		if (paymentArr.length === 0) {
			const emojis = world.bodies.filter((body) => !body.isStatic);
			Matter.Composite.remove(world, emojis);
			return;
		}

		// If a new emoji is added: Drop the last one in the list
		const lastEmoji = paymentArr[paymentArr.length - 1];
		if (lastEmoji) {
			const radius = 20;
			const minX = 160;
			const maxX = 440;
			const randomX = Math.floor(
				Math.random() * (maxX - minX + 1) + minX
			);

			// Start slightly above the top of the canvas (y = -50) for a "drop in" effect
			const emojiBody = Matter.Bodies.circle(randomX, -50, radius, {
				restitution: 0.6,
				friction: 0.1,
				render: {
					sprite: {
						texture: createEmojiTexture(lastEmoji, radius * 2),
					},
				},
			});
			Matter.Composite.add(world, emojiBody);
		}
	}, [paymentArr]);

	// Helper to draw emoji to texture
	const createEmojiTexture = (char, size) => {
		const canvas = document.createElement('canvas');
		canvas.width = size * 2;
		canvas.height = size * 2;
		const ctx = canvas.getContext('2d');
		if (ctx == null) {
			return;
		}
		ctx.font = `${size}px serif`;
		ctx.textAlign = 'center';
		ctx.textBaseline = 'middle';
		ctx.fillText(char, size, size);
		return canvas.toDataURL();
	};

	return (
		<div style={{ textAlign: 'center', padding: '20px' }}>
			<div
				ref={sceneRef}
				style={{ display: 'inline-block', border: '2px solid #ccc' }}
			/>
		</div>
	);
};

export default EmojiBucket;
